import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'gatsby'

import CarouselItem from '../carousel/carousel-item'

import image from '../../images/the-lancashire-hotpots-hotpotmania-tour-2026.jpg'

const newsUrl = '/news/2026-05-29/hotpotmania-tour-on-sale/'

const HotpotmaniaTourCarouselItem = ({ active }) => (
  <CarouselItem
    img={image}
    imgAlt={`A promotional image of the Lancashire Hotpots for their 2026 Hotpotmania tour dates`}
    active={active}
  >
    <Link to={newsUrl} className='btn btn-danger btn-sm btn-block d-md-none'>
      Hotpotmania Tour On Sale Now
    </Link>
    <Link to={newsUrl} className='btn btn-danger btn-block d-none d-md-block'>
      Hotpotmania Tour On Sale Now - click here to view all dates!
    </Link>
  </CarouselItem>
)

HotpotmaniaTourCarouselItem.propTypes = {
  active: PropTypes.bool,
}

HotpotmaniaTourCarouselItem.defaultProps = {
  active: false,
}

export default HotpotmaniaTourCarouselItem
